import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Row,
  Select,
  // Typography,
  Upload,
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { useCreateCity } from 'features/new-clients/use-cases/create-city';
import { useCreateIndustry } from 'features/new-clients/use-cases/create-industry';
import { useDropDownFlag } from 'features/new-clients/use-cases/drop-down';
import { t } from 'i18next';
import { Fragment, useState } from 'react';
import { validateImageBeforeUpload } from 'routes/utils';

import { AssignFormField } from './type';

type AddNewProps = {
  fileList: any[]; // Adjust the type of fileList if you have more specific information
  setFileList: (files: any[]) => void;
  previewImage: string | null; // Assuming previewImage is a URL or null
  setPreviewImage: any;
  previewOpen: boolean;
  setPreviewOpen: (open: boolean) => void;
};
type cityName = {
  text: string;
  value: number;
};
type IndustryName = {
  text: string;
  value: number;
};
export const AddNewInfo = ({
  fileList,
  setFileList,
  previewImage,
  setPreviewImage,
  previewOpen,
  setPreviewOpen,
}: AddNewProps) => {
  const { data: city, refetch: refetchcity } = useDropDownFlag('city');
  const { data: Industry, refetch } = useDropDownFlag('Industry');
  const { mutate, isLoading } = useCreateIndustry();
  const [form] = Form.useForm();
  const { mutate: addcity, isLoading: isLoadingCity } = useCreateCity();
  // const { Text } = Typography;
  const handlePreview = async (file: UploadFile) => {
    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };
  const [isAdding, setIsAdding] = useState(false);
  const [isAddingCity, setIsAddingCity] = useState(false);

  const [newIndustry, setNewIndustry] = useState('');
  const [newCity, setNewCity] = useState('');

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    setFileList(newFileList);
  const handleAddIndustry = async (newIndustry1: any) => {
    const formData = {
      industryName: newIndustry1,
    };
    mutate(formData, {
      onSuccess: (data: any) => {
        if (data?.rs == 1) {
          message.success('Industry added successfully');
        } else {
          message.warning('industry is already added');
        }
        refetch();
      },
    });
    setNewIndustry('');
    setIsAdding(false);
  };
  const handleAddCity = async (newCity1: any) => {
    const formData = {
      countryName: newCity1,
    };
    addcity(formData, {
      onSuccess: (data: any) => {
        if (data?.rs == 1) {
          message.success('City added successfully');
        } else {
          message.warning('City is already added');
        }
        refetchcity();
      },
    });
    setNewCity('');
    setIsAdding(false);
  };
  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type='button'>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );
  const handleDeleteIndustry = (item: IndustryName) => {
    const payload = {
      industryName: item?.text,
      id: item?.value,
    };
    mutate(payload, {
      onSuccess: () => {
        message.success('Industry Delete Successfully');
        refetch();
      },
    });
  };
  const handleDeleteCity = (item: cityName) => {
    const payload = {
      countryName: item?.text,
      id: item?.value,
    };
    addcity(payload, {
      onSuccess: () => {
        message.success('City Delete Successfully');
        refetchcity();
      },
    });
  };
  // const handleCancel = () => {
  //   setNewIndustry('');
  //   setIsAdding(false);
  //   setIsAddingCity(false);
  // };

  return (
    <Fragment>
      <Row gutter={24}>
        <Col xs={24} lg={4}>
          <Form.Item<AssignFormField>
            // label={t('usermanagement.formFields.profile.label')}
            name={AssignFormField.file}
          >
            {/* action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload' */}
            <Upload
              className='uplddocbx'
              listType='picture-card'
              fileList={fileList}
              onPreview={handlePreview}
              onChange={handleChange}
              beforeUpload={validateImageBeforeUpload}
              maxCount={1} // Ensure the Upload takes 100% width
            >
              {fileList?.length >= 1 ? null : (
                <div className='upldbtn'>{uploadButton}</div>
              )}
            </Upload>
            {previewImage && (
              <Image
                wrapperStyle={{ display: 'none' }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(''),
                }}
                src={previewImage}
              />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} lg={20}>
          <Row gutter={24}>
            <Col xs={24} lg={24}>
              <Title level={4}>Basic Information</Title>
            </Col>

            <Col xs={24} lg={6}>
              <Form.Item<AssignFormField>
                label={t('newclient.formFields.clientname.label')}
                rules={[{ required: true, message: 'Name is required' }]}
                name={AssignFormField.Clients}
              >
                <Input
                  placeholder={t('newclient.formFields.clientname.placeholder')}
                />
              </Form.Item>
            </Col>
            <Col xs={24} lg={6}>
              <Form.Item
                label='Industry'
                name='IndustryId'
                rules={[{ required: true, message: 'Industry is required' }]}
              >
                <Select
                  style={{ width: '100%' }}
                  placeholder='Please Select'
                  defaultValue={'Select Industry'}
                  allowClear
                  value={form.getFieldValue('IndustryId')}
                  onChange={(value) =>
                    form.setFieldsValue({ IndustryId: value })
                  } // Update selection
                  options={Industry?.data?.rc.map((item: any) => ({
                    value: item.value,
                    label: (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <span>{item.text}</span>
                        <DeleteOutlined
                          style={{ color: 'red', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteIndustry(item);
                          }}
                        />
                      </div>
                    ),
                  }))}
                  dropdownRender={(menu) => (
                    <div
                      style={{
                        maxHeight: 200,
                        overflowY: 'auto',
                        padding: '8px',
                      }}
                    >
                      {menu}
                      {isAdding ? (
                        <div style={{ padding: 8 }}>
                          <Input
                            value={newIndustry}
                            onChange={(e) => setNewIndustry(e.target.value)}
                            placeholder='Enter new industry'
                            disabled={isLoading}
                            style={{ marginBottom: 8 }}
                          />
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Button
                              type='primary'
                              onClick={() => handleAddIndustry(newIndustry)}
                              loading={isLoading}
                            >
                              Add
                            </Button>
                            <Button
                              type='default'
                              onClick={() => setIsAdding(false)}
                              disabled={isLoading}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 8,
                            cursor: 'pointer',
                          }}
                        >
                          <Button
                            type='link'
                            icon={<PlusOutlined />}
                            onClick={() => setIsAdding(true)}
                          >
                            Add Industry
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                />
              </Form.Item>
            </Col>

            <Col xs={24} lg={6}>
              <Form.Item
                label={t('newclient.formFields.businessname.label')}
                rules={[
                  { required: true, message: 'Business Name is required' },
                ]}
                name={AssignFormField.BusinessName}
              >
                <Input
                  placeholder={t(
                    'newclient.formFields.businessname.placeholder',
                  )}
                />
              </Form.Item>
            </Col>
            <Col xs={24} lg={6}>
              <Form.Item
                label={t('newclient.formFields.city.label')}
                rules={[{ required: true, message: 'City is required' }]}
                name={AssignFormField.CityId}
              >
                {/* <Select
                  options={city?.data?.rc.map((item: cityName) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                  placeholder='Please Select'
                  dropdownRender={() => (
                    <>
                      <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                        {city?.data?.rc.map((item: cityName) => (
                          <div
                            key={item.value}
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '5px 12px',
                              borderBottom: '1px solid #f0f0f0',
                            }}
                          >
                            <span>{item.text}</span>
                            <DeleteOutlined
                              style={{ color: 'red', cursor: 'pointer' }}
                              onClick={() => handleDeleteCity(item)}
                            />
                          </div>
                        ))}
                      </div>

                      {isAddingCity ? (
                        <div style={{ padding: 8 }}>
                          <Input
                            value={newCity}
                            onChange={(e) => setNewCity(e.target.value)}
                            placeholder='Enter new city'
                            disabled={isLoadingCity}
                            style={{ marginBottom: 8 }}
                          />
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Button
                              type='primary'
                              onClick={handleAddCity}
                              loading={isLoadingCity}
                            >
                              Add
                            </Button>
                            <Button
                              type='default'
                              onClick={handleCancel}
                              disabled={isLoadingCity}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 8,
                            cursor: 'pointer',
                          }}
                        >
                          <Button
                            type='link'
                            icon={<PlusOutlined />}
                            onClick={() => setIsAddingCity(true)}
                          >
                            Add City
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                /> */}
                <Select
                  style={{ width: '100%' }}
                  placeholder='Please Select'
                  defaultValue={'Select Industry'}
                  allowClear
                  value={form.getFieldValue('CityId')}
                  onChange={(value) => form.setFieldsValue({ CityId: value })} // Update selection
                  options={city?.data?.rc.map((item: any) => ({
                    value: item.value,
                    label: (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <span>{item.text}</span>
                        <DeleteOutlined
                          style={{ color: 'red', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteCity(item);
                          }}
                        />
                      </div>
                    ),
                  }))}
                  dropdownRender={(menu) => (
                    <div
                      style={{
                        maxHeight: 200,
                        overflowY: 'auto',
                        padding: '8px',
                      }}
                    >
                      {menu}
                      {isAddingCity ? (
                        <div style={{ padding: 8 }}>
                          <Input
                            value={newCity}
                            onChange={(e) => setNewCity(e.target.value)}
                            placeholder='Enter new city'
                            disabled={isLoading}
                            style={{ marginBottom: 8 }}
                          />
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Button
                              type='primary'
                              onClick={() => handleAddCity(newCity)}
                              loading={isLoadingCity}
                            >
                              Add
                            </Button>
                            <Button
                              type='default'
                              onClick={() => setIsAddingCity(false)}
                              disabled={isLoading}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 8,
                            cursor: 'pointer',
                          }}
                        >
                          <Button
                            type='link'
                            icon={<PlusOutlined />}
                            onClick={() => setIsAddingCity(true)}
                          >
                            Add City
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                />
              </Form.Item>
            </Col>

            <Col xs={24} lg={6}>
              <Form.Item
                label={t('newclient.formFields.phoneNumber.label')}
                rules={[
                  { required: true, message: 'Phone number is required' },
                ]}
                name={AssignFormField.PhoneNumber}
              >
                <Input
                  placeholder={'Enter Phone Number'}
                  onKeyPress={(e) => {
                    const isNumber = /^[0-9]$/.test(e.key);
                    const isBackspace = e.key === 'Backspace';
                    if (!isNumber && !isBackspace) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} lg={6}>
              <Form.Item
                label={t('newclient.formFields.email.label')}
                rules={[
                  { required: true, message: 'Email is required' }, // Required validation
                  {
                    type: 'email',
                    message: 'Please enter a valid email address',
                  }, // Email format validation
                ]}
                name={AssignFormField.Email}
              >
                <Input placeholder={'Enter Email'} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={6}>
              <Form.Item
                label={t('newclient.formFields.Locationdetails.label')}
                rules={[{ required: true, message: 'Address is required' }]}
                name={AssignFormField.Address}
              >
                <Input
                  placeholder={t(
                    'newclient.formFields.Locationdetails.placeholder',
                  )}
                />
              </Form.Item>
            </Col>
            <Col xs={24} lg={6}>
              <Form.Item
                label={t('newclient.formFields.businesswebsite.label')}
                rules={[
                  { required: true, message: 'Business website is required' },
                ]}
                name={AssignFormField.BusinessWebsite}
              >
                <Input placeholder={'Enter Business Website'} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={24}>
              <Form.Item
                label={t('newclient.formFields.decription.label')}
                name='Description'
                rules={[{ required: true, message: 'Decription is required' }]}
              >
                <TextArea
                  cols={5}
                  rows={5}
                  placeholder={t('newclient.formFields.decription.placeholder')}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
};
